import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Breadcrumb } from '@printdeal/ui-library';

import { dispatchAccountEvent } from '../../../../helpers/dataLayerHelpers/accountDataLayerHelper';

interface OrderDetailBreadCrumbsProps {
  orderNumber?: string;
}

const OrderDetailBreadCrumbs = ({ orderNumber }: OrderDetailBreadCrumbsProps) => {
  const intl = useIntl();

  return (
    <Breadcrumb
      className="pd-mb-5"
      aria-label={intl.formatMessage({
        id: 'account.order.detail.breadcrumbs',
        defaultMessage: 'Order detail breadcrumbs',
      })}
    >
      <Breadcrumb.Item
        href="../.."
        onClick={() => {
          dispatchAccountEvent('order_detail_interaction', 'breadcrumb_to_home');
        }}
      >
        <FormattedMessage id="breadcrumb.home" defaultMessage="Home" />
      </Breadcrumb.Item>
      <Breadcrumb.Item
        href=".."
        onClick={() => {
          dispatchAccountEvent('order_detail_interaction', 'breadcrumb_to_account_dashboard');
        }}
      >
        <FormattedMessage id="account.index.title" defaultMessage="My account" />
      </Breadcrumb.Item>
      <Breadcrumb.Item
        href="./."
        onClick={() => {
          dispatchAccountEvent('order_detail_interaction', 'breadcrumb_to_order_overview');
        }}
      >
        <FormattedMessage id="account.orders.title" defaultMessage="Order title" />
      </Breadcrumb.Item>
      <Breadcrumb.Item isCurrentPage>
        <FormattedMessage id="account.orders.detail.title" defaultMessage="Order" />
        {' '}
        {orderNumber || '...'}
      </Breadcrumb.Item>
    </Breadcrumb>
  );
};

export default OrderDetailBreadCrumbs;
